import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import { HeadingRegular, BodyR, Button } from '@pensionbee/honeypot-ui';
import { RadioGroup } from '../../../../shared/components/radioGroup/radioGroup';
import { StageProps } from '../../config/StrongerNudgeConfig';

interface QualifyingFormValues {
  qualifyingAnswer: string;
}

export const QualifyingQuestionPartial = ({
  answers,
  onSubmit,
}: StageProps) => {
  const { control, handleSubmit, watch } = useForm<QualifyingFormValues>({
    defaultValues: {
      qualifyingAnswer: (answers.qualifyingAnswer as string) ?? '',
    },
  });

  const watchValue = watch('qualifyingAnswer');

  const handleFormSubmit = async (data: QualifyingFormValues) => {
    await onSubmit({ qualifyingAnswer: data.qualifyingAnswer });
  };

  return (
    <div>
      <form
        onSubmit={handleSubmit(handleFormSubmit)}
        data-testid="qualifying-question-form"
      >
        <div className="mb-28">
          <HeadingRegular
            className="mb-20"
            data-testid="qualifying-question-page-header"
          >
            Are you transferring a pension to PensionBee for the purpose of
            accessing your pension savings in the foreseeable future?
          </HeadingRegular>
          <BodyR data-testid="qualifying-question-page-description">
            You can withdraw money from your pension from the age of 55 (rising
            to 57 in 2028).
          </BodyR>
        </div>

        <div className="pb-28">
          <Controller
            name="qualifyingAnswer"
            control={control}
            render={({ field }) => (
              <RadioGroup
                label=""
                value={field.value}
                onChange={field.onChange}
                options={[
                  {
                    label: 'Yes',
                    value: 'Yes',
                  },
                  {
                    label: 'No',
                    value: 'No',
                  },
                ]}
              />
            )}
          />
        </div>
        <Button
          type="submit"
          disabled={!watchValue}
          variant="primary-yellow"
          className="w-full"
        >
          Next
        </Button>
      </form>
    </div>
  );
};
